// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"492":"f2a8ea9d","567":"6c1ceda4","659":"012b1d6e","700":"6f57d69d","814":"d950a4d8","993":"c846891a"}[chunkId] + ".chunk.css";
};